import React, { useEffect, useState } from 'react';
import { useData } from '../../hooks/useData';
import { useToast } from '../../hooks/useToast';
import { Tag } from '../common/Tag';
import Pagination from '../../hooks/Pagination';
import { userServices } from '../../APIServices/userServices';
import Moment from 'react-moment';

function LogHistory() {
  const { currentUserData } = useData();

  const [logList, setLogList] = useState([]);
  const [logCount, setLogCount] = useState(0);

  const [loading, setLoading] = useState(false);

  const [searchData, setSearchData] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(logCount / itemsPerPage);

  const getUserLoginHistory = async (e) => {
    setLoading(true);
    let data = await userServices.getUserLoginHistory(
      currentUserData?.userId,
      "all",
      searchData,
      pageNumber,
      itemsPerPage
    );
    setLogList(data?.data || []);
    setLogCount(data?.count || 0);
    setLoading(false);
  };
  console.log("logList>>>>>>>>>>>>", logList);
  
  useEffect(() => {
    getUserLoginHistory(pageNumber, itemsPerPage);
  }, [currentUserData?.userId, pageNumber, itemsPerPage]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-eyebrow">
            Governance
          </div>

          <h1 className="page-title">
            Log History
          </h1>

          <p className="page-sub">
            View and track all system activities, user actions, and changes performed
            across the platform. Use the log history to monitor events, audit records,
            and troubleshoot issues efficiently.
          </p>
        </div>
      </div>

      <div className="flex between center mb-3">
        <div className="section-label">
          Log History{' '}
          <span className="count">
            {logCount}
          </span>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
            }}
          >
            <div className="buttonLoader" />

            <div
              style={{
                marginTop: 12,
              }}
            >
              Loading logs...
            </div>
          </div>
        ) : logCount === 0 ? (
          <div
            style={{
              padding: 24,
              textAlign: 'center',
              color: 'var(--ink-3)',
            }}
          >
            <i
              className="ti ti-users"
              style={{
                fontSize: 24,
                display: 'block',
                marginBottom: 8,
              }}
            />

            No Logs.
          </div>
        ) : (
          <>
            <table className="tbl">
              <thead>
                <tr>
                  <th>IP Address</th>
                  <th>Location</th>
                  <th>TimeZone</th>
                  <th>UserId</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>In Out Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {logList?.map((item) => (
                  <tr key={item.id}>
                    <td>{item.ipAddress}</td>
                    <td>{item.location}</td>
                    <td>{item.timeZone}</td>
                    <td>{item.userName}</td>
                    <td>{item.email}</td>
                    <td>
                      <Tag variant={item.status === "login" ? "ok" : item.status === "logout" ? "danger" : "default"}>
                        {item.status}
                      </Tag>
                    </td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Pagination
              totalPage={totalPage}
              pageNumber={pageNumber}
              itemsPerPage={itemsPerPage}
              totalItems={logCount}
              setItemsPerPage={setItemsPerPage}
              setPageNumber={setPageNumber}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default LogHistory;